import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Card,
  CardMedia,
  Typography,
  Box,
  Tabs,
  Tab
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PosterGridDialog = ({ open, onClose, currentItemPosters }) => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (_, newIndex) => setTabIndex(newIndex);

  const renderImageGrid = (images, label) => {
    if (!images || images.length === 0) {
      return (
        <Box textAlign="center" py={4}>
          <Typography>No {label.toLowerCase()} available</Typography>
        </Box>
      );
    }

    return (
      <Grid container spacing={2}>
        {images.map((img, index) => (
          <Grid item xs={12} sm={6} md={6} lg={6} key={index}>
            <Card sx={{ boxShadow: 2 }}>
              <CardMedia
                component="img"
                height="200"
                image={`https://image.tmdb.org/t/p/w500${img?.file_path}`}
                alt={`${label} ${index + 1}`}
                sx={{
                  objectFit: 'contain',
                  borderRadius: 1
                }}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant="h6" component="span" fontSize='16px' fontWeight='bold'>Images</Typography>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignSelf:'center',
            borderBottom: 1,
            borderColor: 'divider',
          }}
          TabIndicatorProps={{
            style: {
              backgroundColor: '#000',
              height: 3,
            },
          }}
      >
        <Tab
          label="Posters"
          sx={{
            color: '#555',
            '&.Mui-selected': {
              color: '#000',
              fontWeight: 'bold',
            },
            textTransform: 'none',
            fontSize: '16px',
            mx: 2, // optional spacing
          }}
        />
        <Tab
          label="Backdrops"
          sx={{
            color: '#555',
            '&.Mui-selected': {
              color: '#000',
              fontWeight: 'bold',
            },
            textTransform: 'none',
            fontSize: '16px',
            mx: 2, // optional spacing
          }}
        />
      </Tabs>

      <DialogContent dividers>
        {tabIndex === 0
          ? renderImageGrid(currentItemPosters?.posters, 'Posters')
          : renderImageGrid(currentItemPosters?.backdrops, 'Backdrops')}
      </DialogContent>
    </Dialog>
  );
};

export default PosterGridDialog;
